export const wrapper = {
  display: "flex",
  flexDirection: "column",
  justifyContent: "center",
  alignItems: "center",
}

export const title = {
  mb: { xs: 1, md: 2 },
  fontSize: { xs: 20, lg: 24 },
  fontWeight: 700,
  lineHeight: 1.33,
}

export const content = {
  mb: { xs: 2, md: 4 },
  textAlign: "center",
}

export const buttonWrapper = {
  width: "100%",
  display: "grid",
  gridTemplateColumns: "repeat(auto-fit, minmax(200px, 1fr))",
  flexDirection: { xs: "column", sm: "row" },
  gap: 2,
}

export const link = {
  textDecoration: "none",
  color: "white",
  underline: "none",
}
